<template>
    <div id="main">
        <container-loader v-if="isLoading"/>
        <div class="page page-container">
            <div class="form-columns-fit">
                <div class="columns is-flex-wrap">
                    <div class="column is-3">
                        <div class="image-box">
                            <div
                                class="image-as-background"
                                :style="{
                                'background-image': apiPartner.imgurl ? 'url(\'' + apiPartner.imgurl + '\') ' : 'url('+ require('@/assets/img/icons/no-image.svg') + ')',
                                }">
                            </div>
                        </div>
                    </div>

                    <div class="column is-9">
                        <div class="listing-header">
                            <div class="title-breadcrumb">
                                <h1 class="title">
                                    {{apiPartner.nome}}
                                </h1>
                                <p>
                                    <strong>{{$t("fornecido-por")}}: </strong>{{apiPartner.descricaopartner}}
                                </p>
                                <p>
                                    <strong>{{$t("categoria")}}: </strong>{{apiPartner.descricaoapicategoria}}
                                </p>
                            </div>
                            <div class="header-buttons">
                                <b-button
                                    :type="apiassclientesovisapipartner.situacao == 1 ? 'is-danger' : 'is-success'"
                                    @click="ativarIntegracao()"
                                    :label="$t(apiassclientesovisapipartner.situacao == 1 ? 'desativar' : 'ativar')"
                                    :icon-right="apiassclientesovisapipartner.situacao == 1 ? 'delete' : 'check'"
                                    position="is-left" 
                                    v-tippy 
                                    :title="$t(apiassclientesovisapipartner.situacao == 1 ? 'desativar' : 'ativar')"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="column is-12">
                        <p v-html="apiPartner.descricaoapipartner">
                        </p>
                    </div>
                    <div class="column is-12">
                        <b-carousel-list
                            as-indicator
                            v-model="values"
                            :data="apiPartner.imagens"
                            :arrow=true
                            :items-to-show=6
                            :has-opacity=true
                            @switch="showModalExibirImagemApi" />
                    </div>
                </div>
            </div>
        </div>
        <div class="page page-container">
            <p class="strong">
                {{$t("sobre-produto")}}
            </p>
            <p v-html="apiPartner.sobreapipartner"></p>
        </div>
        <div class="page page-container">
            <p class="strong">
                {{$t("condicoes-comerciais")}}
            </p>
            <p v-html="apiPartner.condicaoapipartner"></p>
        </div>
        <b-modal :active.sync="showModalExibirImagem">
            <ExibirImagemApiModal
                :selected="objSelecionados"
                @fecharModal="fecharModalExibirImagemApi"
            />
        </b-modal>
    </div>
</template>

<script>
import ApiAssClienteSovisApiPartnerService from "@/services/ApiAssClienteSovisApiPartnerService";
import ExibirImagemApiModal from "@/components/integracao/modal/ExibirImagemApiModal";
import ApiPartnerService from "@/services/ApiPartnerService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        ExibirImagemApiModal,
        ContainerLoader,
    },
    data() {
        return {
            serviceapiassclienteapi: new ApiAssClienteSovisApiPartnerService(this.$http, this.$router),
            service: new ApiPartnerService(this.$http, this.$router),
            showModalExibirImagem: false,
            values: 1,
            objSelecionados: null,
            apiassclientesovisapipartner:{
                id: null,
                situacao: 0,
            },
            apiPartner: {
                imagens: [],
            },
            isLoading: false,
        }
    },
    created(){
        this.carregarDados()
    },
    methods: {
        carregarDados(){
            this.buscarApiPartner();
            this.buscarApiAssClienteSovisApiPartner();
        },
        buscarApiPartner(){
            this.isLoading = true;
            this.service
                .find(this.$route.params.id)
                .then(api => {
                    this.mapApiPartner(api)
                })
                .finally(()=>{
                    this.isLoading = false;
                })
        },
        mapApiPartner(api){
            this.apiPartner.imagens = api.imagens 
                ? api.imagens.map(i =>{ return { image: i.url }})
                : null;
            this.apiPartner.descricaoapipartner = api.descricao;
            this.apiPartner.descricaopartner = api.partner.nome;
            this.apiPartner.descricaoapicategoria = api.apiCategoria.descricao;
            this.apiPartner.sobreapipartner = api.sobre;
            this.apiPartner.nome = api.nome;
            this.apiPartner.condicaoapipartner = api.condicao;
            this.apiPartner.imgurl = api.imgurl;
        },
        showModalExibirImagemApi(value) {
            this.objSelecionados = {
                imagemSelected: this.apiPartner.imagens[value],
                imagens: this.apiPartner.imagens,
                index: value,
            }
            this.showModalExibirImagem = !this.showModalExibirImagem;
        },
        fecharModalExibirImagemApi() {
            this.objSelecionados = null
            this.showModalExibirImagem = false;
        },
        buscarApiAssClienteSovisApiPartner(){
            this.isLoading = true;
            this.serviceapiassclienteapi
                .getByIdApiPartner(this.$route.params.id)
                .then(obj => {
                    this.mapApiAssClienteSovisApiPartner(obj.content)
                }).finally(() => {
                    this.$forceUpdate();
                    this.isLoading = false;
                });
        },
        mapApiAssClienteSovisApiPartner(obj){
            if(obj){
                this.apiassclientesovisapipartner.id = obj.id
                this.apiassclientesovisapipartner.idclientesovis = obj.idclientesovis
                this.apiassclientesovisapipartner.apipartnerid = obj.apipartnerid
                this.apiassclientesovisapipartner.situacao = obj.situacao
                this.apiassclientesovisapipartner.token = obj.tokenintegracao
            }
        },
        ativarIntegracao(){
            if(this.apiassclientesovisapipartner.situacao == 1){
                let message = this.$t('msg-desativacao-api');
                this.$root.confirm({
                    message: message,
                    onConfirm: this.saveIntegracao,
                    onCancel: this.removePrompt,
                });
            } else {
                this.saveIntegracao()
            }
        },
        saveIntegracao(){
            this.serviceapiassclienteapi.save(this.mapIntegracao(this.apiassclientesovisapipartner))
                .then((value) => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$root.showMessage(
                            "success",
                            value.content.situacao == 0
                                ? 'msg-sucesso-ao-desativar-integracao'
                                : 'msg-sucesso-ao-ativar-integracao'
                        );
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", "msg-erro-load", true));
                })
                .finally(() => {
                    this.buscarApiAssClienteSovisApiPartner();
                });
        },
        mapIntegracao(obj){
            return {
                id: obj.id,
                idclientesovis: obj.idclientesovis,
                apipartnerid: this.$route.params.id,
                tokenintegracao: null,
                situacao: obj.situacao == 1 ? 0 : 1,
                usuarioidlog: obj.usuarioidlog ? obj.usuarioidlog : 0,
            }
        },
    }
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}
.strong{
    font-size: 20px !important;
    font-weight: bold !important;
}
.page {
    position: relative;
    padding: 30px !important;
    height: auto !important;
    background-color: $sovis-white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 30px;
}

.form-buttons {
    right: 0;
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}

.image-box{
    flex-grow: 0;
    height: 150px;
    width: 100%;
    .image-as-background {
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        height: 100%;
    }
}
h1.title {
    margin-right: 540px;
}
</style>
